<template>
    <header class="ui-page-header">
        <router-link v-if="back" :to="back" class="ui-eyebrow"><v-icon small>mdi-arrow-left</v-icon>{{ backText }}</router-link>
        <div class="ui-page-header__row">
            <div>
                <div class="ui-page-header__title-row">
                    <h1 class="ui-title">{{ title }}</h1>
                    <slot name="title-append"></slot>
                </div>
                <p v-if="subtitle || $slots.subtitle" class="ui-subtitle"><slot name="subtitle">{{ subtitle }}</slot></p>
            </div>
            <div v-if="$slots.default" class="ui-page-header__actions">
                <slot></slot>
            </div>
        </div>
        <div v-if="$slots.below" class="mt-3">
            <slot name="below"></slot>
        </div>
    </header>
</template>

<script>
// Cabecalho de pagina: link "← Voltar" opcional, titulo, subtitulo e acoes
// (slot padrao). Slots: title-append (badge ao lado do titulo), subtitle, below.
export default {
    name: "UiPageHeader",
    props: {
        title: { type: String, required: true },
        subtitle: { type: String, default: null },
        back: { type: [String, Object], default: null },
        backText: { type: String, default: "Voltar" },
    },
};
</script>
